export default __webpack_public_path__ + "static/media/cny-188-id.0ada188f.webp";